import React from 'react';
import { useDispatch } from 'react-redux';
import { useLoadSteps } from '@/features/query-builder/hooks';
import ViewRef from '@/util/ViewRef';
import { useAppSelector } from '@/store/hooks';
import { selectLastUpdateMethod } from '@/features/query-builder-steps/queryBuilderStepsSlice';
import { LAST_UPDATE_METHOD } from '@/features/query-builder-steps/constants';

export const useReplaceLocalStepsWithFetchedSteps = () => {
  const dispatch = useDispatch();
  const loadedQueryStepsResult = useLoadSteps();
  const lastUpdateMethod = useAppSelector(selectLastUpdateMethod);

  React.useEffect(() => {
    if (loadedQueryStepsResult.status === 'fulfilled') {
      if ('queryId' in loadedQueryStepsResult.data) {
        const view = ViewRef.build(loadedQueryStepsResult.data._viewRef);
        dispatch({
          type: 'VIEW_LOADED',
          payload: { json: loadedQueryStepsResult.data, view },
        });
      } else if (lastUpdateMethod !== LAST_UPDATE_METHOD.saveQuery) {
        dispatch({
          type: 'SHARED_ROWS_REQUEST_LOADED',
          payload: { json: loadedQueryStepsResult.data },
        });
      }
    }
  }, [
    loadedQueryStepsResult.data,
    loadedQueryStepsResult.status,
    lastUpdateMethod,
  ]);
};
